<template>
  <!-- 碎片公式配置 -->
  <div class="debris_formula_config-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)"
            >添加碎片兑换配置</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="配置ID" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="合成公式"
          align="center"
          width="600px"
        >
          <template slot-scope="{ row }">
            <div class="formula-box">
              <div class="goods-info">
                <img style="width: 50px" :src="row.prize.image" alt="" />
                <p>{{ row.prize.name }}</p>
              </div>
              <span style="font-size: 20px; margin: 0px 10px">=</span>
              <div
                class="debris-info-item"
                v-for="item in row.content"
                :key="item.id"
              >
                <div class="debris-info">
                  <div class="debris-img">
                    <img :src="item.image" alt="" />
                  </div>
                  <p>
                    <span style="color: green">x{{ item.num }}</span>
                  </p>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="synthetic_count"
          label="已合成数量"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openDialog(2, row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <DebrisFormulaDialog
      v-model="dialogInfos"
      :visible="addVisible"
      :type="dialogType"
      @close="addVisible = false"
      @refresh="getData()"
    ></DebrisFormulaDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import DebrisFormulaDialog from '../../components/debrisActivity/DebrisFormulaDialog.vue'

export default {
  components: {
    DebrisFormulaDialog
  },
  data() {
    return {
      addVisible: false,//添加队伍弹窗显示标志
      loading: false,//加载动画
      dataList: undefined,//数据列表
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('debris_goods')
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    handleDelete(row) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`debris_goods/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleExport() {
      this.buttonLoading = true

      http
        .get(
          api + 'user_debris_goods_export',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '用户合成记录.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  }
}
</script>
<style lang="less" scoped>
.formula-box {
  display: flex;
  // justify-content: center;
  align-items: center;
  font-size: 12px;
  .goods-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .debris-info-item {
    margin-right: 5px;
    .debris-info {
      .debris-img {
        border: 2px solid rgb(105, 202, 25);
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>